/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';

/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LOADER : ELLIPSIS
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    ellipsis: {
        marginBottom: pxToEm(10),
        display: 'inline-block',
        position: 'relative',
        width: pxToEm(80),
        height: pxToEm(60),
        opacity: 0,
        animationName: 'fadeIn',
        animationDuration: '2s',
        animationFillMode: 'forwards',
        '& div': {
            position: 'absolute',
            top: pxToEm(23),
            width: pxToEm(13),
            height: pxToEm(13),
            borderRadius: '50%',
            background: '#fff',
            opacity: 0.8,
            animationTimingFunction: `cubic-bezier(0, 1, 1, 0)`,
            '&:nth-child(1)': {
                left: pxToEm(8),
                animation: `ellipsis1 0.75s infinite`
            },
            '&:nth-child(2)': {
                left: pxToEm(8),
                animation: `ellipsis2 0.75s infinite`
            },
            '&:nth-child(3)': {
                left: pxToEm(32),
                animation: `ellipsis2 0.75s infinite`
            },
            '&:nth-child(4)': {
                left: pxToEm(56),
                animation: `ellipsis3 0.75s infinite`
            }
        }

    },
    [`@keyframes ellipsis1`]: {
        '0%': { transform: 'scale(0)' },
        '100%': { transform: 'scale(1)' }
    },
    [`@keyframes ellipsis3`]: {
        '0%': { transform: 'scale(1)' },
        '100%': { transform: 'scale(0)' }
    },
    [`@keyframes ellipsis2`]: {
        '0%': { transform: 'translate(0, 0)' },
        '100%': { transform: `translate(${pxToEm(24)}, 0)` }
    }
};
